/*
 * HeaderFormatter Messages
 *
 * This contains all the text for the HeaderFormatter component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    assignStudents: {
        id: 'app.components.StudentCountFormatter.assignStudents',
        defaultMessage: 'Assign students'
    }
});



// WEBPACK FOOTER //
// ./app/components/formatters/student-count-formatter/messages.js